import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  addReqBuilderCandidateRoutine,
  fetchReqBuilderContactsRoutine,
  updateSelectedCandidateRoutine
} from '../../routines';
import { getContactIfExists, getAllContacts, checkPhoneNumber } from '../../../../services/contactService';
import { errorToast } from '../../../../common/helpers/toastrHelper';
import { unreachablePhone } from '../../components/AddContactForm/utils';

function* getContacts({ payload }: Routine<any>) {
  try {
    const response = yield call(getAllContacts, payload);
    const data = {
      ...response,
      reset: !payload.from
    };

    yield put(fetchReqBuilderContactsRoutine.success(data));
  } catch {
    yield put(fetchReqBuilderContactsRoutine.failure());
  }
}

function* watchGetContactsRequest() {
  yield takeEvery(fetchReqBuilderContactsRoutine.TRIGGER, getContacts);
}

function* updateCandidate({ payload }: Routine<any>) {
  try {
    let isValidPhoneNumber = true;

    if (payload.data.phoneNumber) {
      const { isValid } = yield call(checkPhoneNumber, payload.data.phoneNumber);
      isValidPhoneNumber = isValid;
    }

    if (isValidPhoneNumber) {
      const data = yield call(getContactIfExists, {
        email: payload.data.email,
        phoneNumber: payload.data.phoneNumber,
        excludeIds: payload.id && [payload.id]
      });
      const { lastRole, ...contactData } = data || {};
      const updatedData = { ...payload.data, ...contactData };
      yield put(updateSelectedCandidateRoutine.success({ ...payload, data: updatedData }));
    } else {
      yield call(errorToast, unreachablePhone.message, unreachablePhone.id);
    }
  } catch {
    yield put(updateSelectedCandidateRoutine.failure());
  }
}

function* watchUpdateCandidate() {
  yield takeEvery(updateSelectedCandidateRoutine.TRIGGER, updateCandidate);
}

function* checkAndAddCandidate({ payload }: Routine<any>) {
  try {
    let isValidPhoneNumber = true;
    if (payload.phoneNumber) {
      const { isValid } = yield call(checkPhoneNumber, payload.phoneNumber);
      isValidPhoneNumber = isValid;
    }

    if (isValidPhoneNumber) {
      yield put(addReqBuilderCandidateRoutine.success(payload));
    } else {
      yield call(errorToast, unreachablePhone.message, unreachablePhone.id);
    }
  } catch (error) {
    yield put(addReqBuilderCandidateRoutine.failure(error.message));
  }
}

function* watchAddCandidate() {
  yield takeEvery(addReqBuilderCandidateRoutine.TRIGGER, checkAndAddCandidate);
}

export default function* step2Saga() {
  yield all([watchGetContactsRequest(), watchUpdateCandidate(), watchAddCandidate()]);
}
